export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.14-1419.20",
  commitId: "714b4ca30df086808e0243061ea6f034b60e6147",
  commitTime: "2026-09-14T14:19:20.000Z",
});
